<template>
  <div class="accordion-item white-bg-color table-border">
    <h2 class="fila-accordion accordion-header d-flex justify-content-around align-items-center" id="headingOne">
      <div class="table-text col-2 text-sm p-2 text-center border-start border-bottom border-end border-dark">
        {{ this.seedData.seed.provider.name }}
      </div>
      <div class="table-text col-3 text-sm p-2 text-center border-end border-bottom border-dark">
        {{ this.seedData.seed.name }}
      </div>
      <div class="table-text col-3 text-sm p-2 text-center border-end border-bottom border-dark">{{
          parseDollars(this.calculations.totalCost) }}</div>
      <div class="table-text col-3 text-sm p-2 text-center border-end border-bottom border-dark">{{
          parseDollars(this.calculations.profit) }}</div>
      <div class="col-1 p-1 text-center justify-content-center div-container-accordion-button">
        <button class="accordion-button collapsed" id="whiteAccordionButton" type="button" data-bs-toggle="collapse"
          :data-bs-target="`#accordion-${this.accordionNumber}`" aria-expanded="true"
          :aria-controls="`accordion-${this.accordionNumber}`"></button>
      </div>
    </h2>
    <div :id="`accordion-${this.accordionNumber}`" class="accordion-collapse collapse accordion-opened"
      :aria-labelledby="`accordion-${this.accordionNumber}`">
      <div class="w-100 d-flex justify-content-around">
        <!-- Repeat table-info class instead of putting it on the Table head to prevent the empty cell to have a little background-color border -->
        <div class="col-2 p-1 p-2 text-center table-info table-info-first">Proveedor</div>
        <div class="col-3 p-1 p-2 text-center table-info ">Nombre</div>
        <div class="col-3 p-1 p-2 text-center table-info">Coste</div>
        <div class="col-3 p-1 p-2 text-center table-info">Rentabilidad</div>
        <div class="col-1 p-1 p-2 div-accordion-button-rentabilidad">
          <button class="accordion-button collapsed" id="whiteAccordionButton" type="button" data-bs-toggle="collapse"
            :data-bs-target="`#accordion-${this.accordionNumber}`" aria-expanded="true"
            :aria-controls="`accordion-${this.accordionNumber}`"></button>
        </div>
      </div>
      <h2 class="fila-accordion accordion-header d-flex justify-content-around align-items-center" id="headingOne">
        <div class="table-text col-2 text-sm p-2 text-center border-start border-bottom border-end border-dark">
          {{ this.seedData.seed.provider.name }}
        </div>
        <div class="table-text col-3 text-sm p-2 text-center border-end border-bottom border-dark">
          {{ this.seedData.seed.name }}
        </div>
        <div class="table-text col-3 text-sm p-2 text-center border-end border-bottom border-dark">{{
          parseDollars(this.calculations.totalCost) }}</div>
        <div class="table-text col-4 text-sm p-2 text-center border-end border-bottom border-dark">{{
          parseDollars(this.calculations.profit) }}</div>
        <!-- <div class="table-text col-1 p-1 text-center justify-content-center border-bottom border-dark">
        <button class="accordion-button collapsed" id="whiteAccordionButton" type="button" data-bs-toggle="collapse"
          :data-bs-target="`#accordion-${this.accordionNumber}`" aria-expanded="true"
          :aria-controls="`accordion-${this.accordionNumber}`"></button>
      </div> -->
      </h2>
      <div class="d-flex justify-content-around w-100 border-dark">
        <div class="col-3 p-1 border-start border-dark text-inside-accordion">Rendimiento por hectarea</div>
        <div class="col-3 p-1 border-end border-dark text-inside-accordion">
          <n-input placeholder="Rendimiento por hectarea" v-model:value="performancePerHectare"
            @input="getTotalCosts({ bagsInputPerformance: $event })" />
        </div>
        <div class="col-3 p-1 text-inside-accordion">Cosecha estimada en quintales</div>
        <div class="col-3 p-1 text-center border-end border-dark text-inside-accordion">{{
          formatNumber(Math.round(this.calculations.estimatedHarvestInQuintals)) }}</div>
        <!-- <div class="col-1 p-1"></div> -->
      </div>
      <div class="d-flex justify-content-around w-100">
        <div class="col-3 p-1 border-start border-top border-dark text-inside-accordion">Bolsas por hectarea</div>
        <div class="col-3 p-1 border-end border-top border-dark">
          <n-input placeholder="Bolsas por hectarea" v-model:value="bagPerHec"
            @input="getTotalCosts({ bagsInputHec: $event })" />
        </div>
        <div class="col-3 p-1 border-top border-dark text-inside-accordion">Bolsas necesarias</div>
        <div class="col-3 p-1 text-center border-end border-top border-dark text-inside-accordion">{{
          formatNumber(this.calculations.bagsNeeded) }}</div>
        <!-- <div class="col-1 p-1"></div> -->
      </div>
      <div class="d-flex justify-content-around w-100 ">
        <div class="col-3 p-1 border-start border-top border-bottom border-dark text-inside-accordion">Precio x bolsa
        </div>
        <div class="col-3 p-1 border-end border-dark border-top border-bottom text-inside-accordion">{{
          parseDollars(this.calculations.pricePerBagPerAmount) }}</div>
        <div class="col-3 p-1 border-top border-dark border-bottom text-inside-accordion">Costo total bolsas</div>
        <div class="col-3 p-1 text-center border-end border-dark border-top border-bottom text-inside-accordion">{{
          parseDollars(this.calculations.bagsCost) }}</div>
        <!-- <div class="col-1 p-1"></div> -->
      </div>
      <div class="col-12 accordion">
        <div class="accordion-item">
          <h2 class="fila-accordion accordion-header d-flex border-bottom border-dark text-center align-items-center"
            id="headingOne">
            <div class="col-3 text-sm p-1">Suministros</div>
            <div class="col-2 text-sm p-1">Costos</div>
            <div class="col-4 text-sm p-1" :class="!areSuppliesOn && 'linethrough'">{{
          parseDollars(this.calculations.supplyCostObject.totalSupplyCost) }}</div>
            <div class="col-2 p-1 d-flex">
              <div class="form-check form-switch">
                <input class="form-check-input switch-suministros" type="checkbox" id="flexSwitchCheckDisabled"
                  @click="toggleAllSupplies($event)" :checked="areSuppliesOn" />
              </div>
            </div>
            <div class="col-1 p-1 d-flex div-accordion-button-inside">
              <button class="accordion-button collapsed accordion-button-inside" type="button" data-bs-toggle="collapse"
                :data-bs-target="`#accordion2-${this.accordionNumber}`" aria-expanded="true"
                :aria-controls="`accordion2-${this.accordionNumber}`"></button>
            </div>
          </h2>

          <div :id="`accordion2-${this.accordionNumber}`" class="accordion-collapse collapse"
            :aria-labelledby="`accordion2-${this.accordionNumber}`">
            <div class="d-flex justify-content-around w-100 p-2 gray-background">
              <div class="col-4 p-1">
                <n-select placeholder="Fertilizantes " @update:value="selectSupply($event, 'fertilizer')"
                  :options="this.seedData.fertilizerOptions" :disabled="!areSuppliesOn" />
              </div>
              <div class="col-3 p-1 d-flex justify-content-center align-items-center text-inside-accordion">Dosis x has.
              </div>
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">Costos</div>
              <div class="col-1 p-1"></div>
            </div>

            <div class="d-flex justify-content-around w-100 p-2 border-bottom border-dark gray-background"
              v-for="(supply, i) in this.calculations.supplyCostObject.selectedFertilizerSupplies"
              :key="`rand-${i}-something3`">
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">{{
          supply.name
        }}</div>
              <div class="col-3 p-1 d-flex justify-content-center align-items-center gap-1 text-inside-accordion">
                <input class="custom-input" placeholder="Dosis"
                  v-model="this.calculations.supplyCostObject.selectedFertilizerSupplies[i].dose.value"
                  @input="($event) => { this.getTotalCosts({}) }" :disabled="!areSuppliesOn" />
                {{
          supply.format }}.
              </div>
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">{{
          parseDollars(supply.cost) }}
              </div>
              <div class="col-1 p-1 d-flex justify-content-center align-items-center gap-1 text-inside-accordion">
                <n-button v-if="areSuppliesOn" class="trash-responsive" primary @click="removeSupply(supply.type, i)"><i
                    class="icon-trash" /></n-button>
              </div>
            </div>

            <div class="d-flex justify-content-around w-100 p-2 gray-background text-inside-accordion">
              <div class="col-4 p-1">
                <n-select placeholder="Fitosanitarios " @update:value="selectSupply($event, 'phytosanitary')"
                  v-model:value="phytosanitary" :options="this.seedData.phytosanitaryOptions"
                  :disabled="!areSuppliesOn" />
              </div>
              <div class="col-3 p-1 d-flex justify-content-center align-items-center text-inside-accordion">Dosis x has.
              </div>
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">Costos</div>
              <div class="col-1 p-1"></div>
            </div>
            <div
              class="d-flex justify-content-around w-100 p-2 border-bottom border-dark gray-background text-inside-accordion"
              v-for="(supply, i) in this.calculations.supplyCostObject.selectedPhytosanitarySupplies"
              :key="`rand-${i}-something`">
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">{{
          supply.name
        }}</div>
              <div class="col-3 p-1 d-flex justify-content-center align-items-center gap-1 text-inside-accordion">
                <input class="custom-input" placeholder="Dosis" @input="($event) => { this.getTotalCosts({}) }"
                  :disabled="!areSuppliesOn"
                  v-model="this.calculations.supplyCostObject.selectedPhytosanitarySupplies[i].dose.value" />
                {{
          supply.format }}.
              </div>
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">{{
          parseDollars(supply.cost) }}
              </div>
              <div class="col-1 p-1 d-flex justify-content-center align-items-center gap-1 text-inside-accordion">
                <n-button v-if="areSuppliesOn" class="trash-responsive" primary @click="removeSupply(supply.type, i)"><i
                    class="icon-trash" /></n-button>
              </div>
            </div>

            <!-- <div class="d-flex justify-content-around w-100 p-2 gray-background">
              <div class="col-4 p-1 text-inside-accordion">
                <n-select placeholder="Fert. y Fitosanitarios"
                  @update:value="selectSupply($event, 'fertilizerAndPhytosanitary')"
                  v-model:value="fertilizerAndPhytosanitary" :options="this.seedData.fertilizerAndPhytosanitaryOptions"
                  :disabled="!areSuppliesOn" />
              </div>
              <div class="col-3 p-1 d-flex justify-content-center align-items-center text-inside-accordion">Dosis x has. sdfsdf
              </div>
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">Costos</div>
              <div class="col-1 p-1"></div>
            </div>
            <div
              class="d-flex justify-content-around w-100 p-2 border-bottom border-dark gray-background text-inside-accordion"
              v-for="(supply, i) in this.calculations.supplyCostObject.selectedFertilizerAndPhytosanitarySupplies"
              :key="`rand-${i}-something2`">
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">{{
          supply.name
        }}</div> -->

              <!-- <div class="col-3 p-1 d-flex justify-content-center align-items-center gap-1 text-inside-accordion">
                <input class="custom-input" placeholder="Dosis" @input="($event) => { this.getTotalCosts({}) }"
                  :disabled="!areSuppliesOn"
                  v-model="this.calculations.supplyCostObject.selectedFertilizerAndPhytosanitarySupplies[i].dose.value" />
                {{ supply.format }}.
              </div>
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">{{
          parseDollars(supply.cost) }}
              </div>
              <div class="col-1 p-1 d-flex justify-content-center align-items-center gap-1 text-inside-accordion">
                <n-button v-if="areSuppliesOn" class="trash-responsive" primary @click="removeSupply(supply.type, i)"><i
                    class="icon-trash" /></n-button>
              </div>
            </div> -->





            <div class="d-flex justify-content-around w-100 p-2 gray-background">
              <div class="col-4 p-1 text-inside-accordion">
                <n-select placeholder="Aditivos / Extras " @update:value="selectSupply($event, 'additive')"
                  v-model:value="additive" :options="this.seedData.additiveOptions" :disabled="!areSuppliesOn" />
              </div>
              <div class="col-3 p-1 d-flex justify-content-center align-items-center text-inside-accordion">Dosis x has.
              </div>
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">Costos</div>
              <div class="col-1 p-1"></div>
            </div>
            <div class="d-flex justify-content-around w-100 p-2 border-bottom border-dark gray-background"
              v-for="(supply, i) in this.calculations.supplyCostObject.selectedAdditiveSupplies"
              :key="`rand-${i}-something2`">
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">{{
          supply.name
        }}</div>
              <div class="col-3 p-1 d-flex justify-content-center align-items-center gap-1 text-inside-accordion">
                <input class="custom-input" placeholder="Dosis"
                  v-model="this.calculations.supplyCostObject.selectedAdditiveSupplies[i].dose.value"
                  @input="($event) => { this.getTotalCosts({}) }" :disabled="!areSuppliesOn" />
                {{ supply.format }}.
              </div>
              <div class="col-4 p-1 d-flex justify-content-center align-items-center text-inside-accordion">{{
          parseDollars(supply.cost) }}
              </div>
              <div class="col-1 p-1 d-flex justify-content-center align-items-center gap-1 text-inside-accordion">
                <n-button v-if="areSuppliesOn" class="trash-responsive" primary @click="removeSupply(supply.type, i)"><i
                    class="icon-trash" /></n-button>
              </div>
            </div>
          </div>
        </div>


        <div class="d-flex justify-content-around w-100 border-bottom border-dark">
          <div class="col-4 p-1 border-start border-end border-dark d-flex justify-content-around align-items-center">
            <div class="col-6 p-1 text-inside-accordion">Litros Gasoil x ha</div>
            <div class="col-6 p-1 text-inside-accordion">
              <n-input classplaceholder="Litros de gasoil por hectarea" v-model:value="dose.gasoil"
                @input="getTotalCosts({ gasoilInputDose: $event })" :disabled="!isGasoilOn" />
            </div>
          </div>
          <div class="col-4 p-1 border-end border-dark d-flex justify-content-center align-items-center">
            <div class="col-6 p-1 text-inside-accordion">Precio gasoil x litro</div>
            <div class="col-6 p-1 text-inside-accordion">
              <n-input placeholder="Precio" v-model:value="gasoilPricePerFormat"
                @input="getTotalCosts({ gasoilInputPrice: $event })" :disabled="!isGasoilOn" />
            </div>
          </div>
          <div
            class="col-4 p-1 border-end border-dark d-flex justify-content-around align-items-center d-flex gap-1 text-inside-accordion">
            <div :class="`col-6 table-text p-1 text-center ${!isGasoilOn && 'linethrough'}`">
              {{ parseDollars(this.calculations.gasoilCost) }}
            </div>
            <div class="col-6">
              <div class="form-check form-switch d-flex justify-content-center gasoil-switch">
                <h2>
                  <input class="form-check-input" type="checkbox" id="flexSwitchCheckDisabled"
                    @click="toggleGasoil($event)" :checked="isGasoilOn" />
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1"></div>
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import { mapActions, mapState } from "pinia";
import BigNumber from "bignumber.js";
import productStore from "../store/product";
import supplyStore from "../store/supply";
import planStore from "../store/plan";
import _ from "lodash";
import useConfiguration from '../store/configuration';
import utils from '../service/utils.js'
export default {
  data() {
    return {
      areSuppliesOn: this.seedData.calculationsData.suppliesToggle,
      isGasoilOn: this.seedData.calculationsData.gasoilToggle,
      gasoilCost: this.seedData.calculationsData.gasoilCost,
      gasoilPricePerFormat: this.seedData.calculationsData.gasoilPricePerFormat,
      performancePerHectare: this.seedData.seed.performancePerHectare.estimate,
      bagPerHec: this.seedData.seed.bagsPerHectare.recommended,
      product: '',
      fertilizer: this.calculations?.supplyCostObject?.selectedFertilizerSupplies.map(fertilizer => ({
        ...fertilizer,
        dose: { ...fertilizer.dose, value: fertilizer.dose.value || fertilizer.dose.recommended }
      })),

      phytosanitary: this.seedData.calculationsData.supplyCostObject.selectedPhytosanitarySupplies[0]?.id || null,
      fertilizerAndPhytosanitary: this.seedData.calculationsData.supplyCostObject.selectedFertilizerAndPhytosanitarySupplies[0]?.id || null,
      additive: this.seedData.calculationsData.supplyCostObject.selectedAdditiveSupplies[0]?.id || null,

      dose: {
        gasoil: this.seedData.seed.gasoil.recommended,
        additive: this.seedData.calculationsData.supplyCostObject.selectedAdditiveSupplies[0]?.dose.value || this.seedData.calculationsData.supplyCostObject.selectedAdditiveSupplies[0]?.dose.recommended,
      },
      minDose: {
        gasoil: this.seedData.seed.gasoil.min,
        fertilizer: this.seedData.calculationsData.supplyCostObject.selectedFertilizerSupplies[0]?.dose.min,
        phytosanitary: this.seedData.calculationsData.supplyCostObject.selectedPhytosanitarySupplies[0]?.dose.min,
        additive: this.seedData.calculationsData.supplyCostObject.selectedAdditiveSupplies[0]?.dose.min,
      },
      maxDose: {
        gasoil: this.seedData.seed.gasoil.max,
        fertilizer: this.seedData.calculationsData.supplyCostObject.selectedFertilizerSupplies[0]?.dose.max,
        phytosanitary: this.seedData.calculationsData.supplyCostObject.selectedPhytosanitarySupplies[0]?.dose.max,
        additive: this.seedData.calculationsData.supplyCostObject.selectedAdditiveSupplies[0]?.dose.max,
      },
      recommendedDose: {
        gasoil: this.seedData.seed.gasoil.recommended,
        fertilizer: this.seedData.calculationsData.supplyCostObject.selectedFertilizerSupplies[0]?.dose.recommended,
        phytosanitary: this.seedData.calculationsData.supplyCostObject.selectedPhytosanitarySupplies[0]?.dose.recommended,
        additive: this.seedData.calculationsData.supplyCostObject.selectedAdditiveSupplies[0]?.dose.recommended,
      },
      calculations: this.seedData.calculationsData,
      supplyArraysMap: {
        fertilizer: 'selectedFertilizerSupplies',
        phytosanitary: 'selectedPhytosanitarySupplies',
        fertilizerAndPhytosanitary: 'selectedFertilizerAndPhytosanitarySupplies',
        additive: 'selectedAdditiveSupplies'
      }
    };
  },
  async created() {
    this.debouncedWatch = _.debounce(async (newValue, oldValue) => {
      await this.modifySize(newValue);
    }, 500);
    await this.getProductPrice(this.seedData.seed.product);
    this.getTotalCosts({});
  },
  beforeUnmount() {
    this.debouncedWatch.cancel();
  },
  props: {
    seedData: Object,
    accordionNumber: Number,
    divisionSize: Number,
  },
  computed: {
    ...mapState(planStore, ["storage"]),
    ...mapState(useConfiguration, ["configuration"]),
  },
  watch: {
    divisionSize(...args) {
      this.debouncedWatch(...args);
    },
  },
  methods: {
    ...mapActions(productStore, ["getProductsById"]),
    ...mapActions(supplyStore, ["getSuppliesById"]),
    ...mapActions(planStore, ['calculate', 'processSupply', 'processSupplies']),
    parseDollars(value) {
      return value.toLocaleString('de-DE', { maximumFractionDigits: 0, style: 'currency', currency: 'USD', currencyDisplay: 'code' }).replace('USD', 'u$s');
    },
    async getTotalCosts({ gasoilInputPrice, gasoilInputDose, bagsInputHec, bagsInputPerformance }) {
      try {
        const gasoilDose = utils.formatInputNumber(gasoilInputDose || this.dose.gasoil || this.seedData?.seed?.gasoil?.recommended);
        this.seedData.seed.gasoil.recommended = gasoilDose;

        const gasoilPricePerFormat = utils.formatInputNumber(gasoilInputPrice || this.calculationsData?.gasoilPricePerFormat || this.gasoilPricePerFormat);
        this.calculations.gasoilPricePerFormat = gasoilPricePerFormat;

        const bagPerHec = utils.formatInputNumber(bagsInputHec || this.bagPerHec);
        this.seedData.seed.bagsPerHectare.recommended = bagPerHec;

        const bagsNeeded = this.calculate({ field: 'bagsNeeded', bagPerHec, divisionSize: this.divisionSize });

        const pricePerBagPerAmount = this.getPricePerBagPerAmount(bagsNeeded, this.seedData.seed.pricePerBag);

        const bagsCost = this.calculate({ field: 'bagsCost', bagsNeeded, pricePerBagPerAmount });

        const performancePerHectare = utils.formatInputNumber(bagsInputPerformance || this.performancePerHectare);
        this.seedData.seed.performancePerHectare.estimate = performancePerHectare;

        let estimatedHarvestInTons = this.calculate({ field: 'estimatedHarvestInTons', performancePerHectare, divisionSize: this.divisionSize });

        let estimatedHarvestInQuintals = this.calculate({ field: 'estimatedHarvestInQuintals', estimatedHarvestInTons });

        let seedMarketValue = this.product.price.price;

        let estimatedHarvestValue = this.calculate({ field: 'estimatedHarvestValue', estimatedHarvestInTons, seedMarketValue }); seedtab

        let gasoilCost = this.calculate({ field: 'gasoilCost', gasoilDose, gasoilPricePerFormat, divisionSize: this.divisionSize })

        const {
          selectedAdditiveSupplies: additives,
          selectedPhytosanitarySupplies: phytosanitaries,
          selectedFertilizerAndPhytosanitarySupplies: fertilizerAndPhytosanitaries,
          selectedFertilizerSupplies: fertilizers
        } = this.calculations.supplyCostObject


        // Currently selected supplies

        const { seed: { supplies } } = this.seedData;

        const suppliesToRecalculate = additives
          .concat(phytosanitaries, fertilizerAndPhytosanitaries, fertilizers)
          .map((supply) => {
            const prev = supplies.find((s) => s.supply._id === supply.id);
            return { ...prev, isDefault: true };
          })

        const { supplyCostObject } =
          this.processSupplies(suppliesToRecalculate, this.divisionSize);

        let totalCost;

        if (this.isGasoilOn && this.areSuppliesOn) {
          totalCost = this.calculate({
            field: 'totalCost',
            bagsCost,
            gasoilCost,
            totalSupplyCost: supplyCostObject.totalSupplyCost,
          });
        } else if (!(this.isGasoilOn || this.areSuppliesOn)) {
          totalCost = BigNumber(bagsCost).toNumber();
        } else if (!this.isGasoilOn) {
          totalCost = BigNumber(bagsCost).plus(BigNumber(supplyCostObject.totalSupplyCost)).toNumber();
        } else {
          totalCost = BigNumber(bagsCost).plus(BigNumber(gasoilCost)).toNumber();
        }
        const profit = this.calculate({
          field: 'profit',
          estimatedHarvestValue,
          totalCost,
        });

        const newCalculations = {
          bagsNeeded,
          bagsCost,
          estimatedHarvestInQuintals,
          estimatedHarvestInTons,
          estimatedHarvestValue,
          gasoilCost,
          pricePerBagPerAmount,
          profit,
          seedMarketValue,
          supplyCostObject,
          totalCost,
          suppliesToggle: this.areSuppliesOn,
          gasoilToggle: this.isGasoilOn
        }

        this.calculations = { ...this.calculations, ...newCalculations }
        this.seedData.calculationsData = { ...this.calculations }
      } catch (e) {
        throw e;
      }
    },
    formatNumber(value) {
      return value.toLocaleString('de-DE');
    },
    modifyGasoilPricePerFormat(e) {

      const pricePerFormat = e ? parseFloat(e.toString().replace(/\,/g, '.')) : 0;

      if (pricePerFormat < 0) { return };

      const gasoilDose = parseFloat(this.dose.gasoil.toString().replace(/\,/g, '.'));

      const gasoilCost = this.calculate({ field: 'gasoilCost', gasoilDose, gasoilPricePerFormat: pricePerFormat, divisionSize: this.divisionSize })

      const { bagsCost, estimatedHarvestValue, supplyCostObject: { totalSupplyCost } } = this.calculations;

      let totalCost;
      if (this.areSuppliesOn) {
        totalCost = this.calculate({ field: 'totalCost', bagsCost, gasoilCost, totalSupplyCost })
      } else {
        totalCost = this.calculate({ field: 'totalCost', bagsCost, gasoilCost, totalSupplyCost: 0 })
      }

      const profit = this.calculate({ field: 'profit', estimatedHarvestValue, totalCost })

      this.calculations.gasoilCost = gasoilCost;
      this.calculations.totalCost = totalCost;
      this.calculations.profit = profit;
      this.calculations.gasoilPricePerFormat = pricePerFormat

    },
    async modifySize(newSize) {

      try {
        if (!newSize) return;


        const bagsNeeded = this.calculate({ field: 'bagsNeeded', bagPerHec: this.bagPerHec, divisionSize: newSize })

        const pricePerBagPerAmount = this.getPricePerBagPerAmount(bagsNeeded, this.seedData.seed.pricePerBag);

        const bagsCost = this.calculate({ field: 'bagsCost', bagsNeeded, pricePerBagPerAmount })

        let estimatedHarvestInTons = this.calculate({ field: 'estimatedHarvestInTons', performancePerHectare: this.performancePerHectare, divisionSize: newSize });

        let estimatedHarvestInQuintals = this.calculate({ field: 'estimatedHarvestInQuintals', estimatedHarvestInTons });

        let seedMarketValue = await this.getProductPrice(this.seedData.seed.product);

        let estimatedHarvestValue = this.calculate({ field: 'estimatedHarvestValue', estimatedHarvestInTons, seedMarketValue });

        const gasoilCost = this.gasoilCost;

        const {
          selectedAdditiveSupplies: additives,
          selectedPhytosanitarySupplies: phytosanitaries,
          selectedFertilizerAndPhytosanitarySupplies: fertilizerAndPhytosanitaries,
          selectedFertilizerSupplies: fertilizers
        } = this.calculations.supplyCostObject
        // Currently selected supplies

        const { seed: { supplies } } = this.seedData;

        const suppliesToRecalculate = additives
          .concat(phytosanitaries, fertilizerAndPhytosanitaries, fertilizers)
          .map((supply) => {

            return supplies.find((s) => s.supply._id === supply.id)

          })

        const { supplyCostObject } =
          this.processSupplies(suppliesToRecalculate, newSize);



        let totalCost;

        if (this.isGasoilOn && this.areSuppliesOn) {
          totalCost = this.calculate({
            field: 'totalCost',
            bagsCost,
            gasoilCost,
            totalSupplyCost: supplyCostObject.totalSupplyCost,
          });
        } else if (!(this.isGasoilOn || this.areSuppliesOn)) {
          totalCost = BigNumber(bagsCost).toNumber();
        } else if (!this.isGasoilOn) {
          totalCost = BigNumber(bagsCost).plus(BigNumber(supplyCostObject.totalSupplyCost)).toNumber();
        } else {
          totalCost = BigNumber(bagsCost).plus(BigNumber(gasoilCost)).toNumber();
        }
        const profit = this.calculate({
          field: 'profit',
          estimatedHarvestValue,
          totalCost,
        });
        const newCalculations = {
          bagsNeeded,
          bagsCost,
          estimatedHarvestInQuintals,
          estimatedHarvestInTons,
          estimatedHarvestValue,
          gasoilCost,
          pricePerBagPerAmount,
          profit,
          seedMarketValue,
          supplyCostObject,
          totalCost
        }

        this.calculations = { ...this.calculations, ...newCalculations }
        this.seedData.calculationsData = { ...this.calculations, ...newCalculations }

      } catch (e) {
        throw e;
      }
    },
    async modifySupplyDose(e, supplyId) {
      let newDose = e ? parseFloat(e.target.value.toString().replace(/\,/g, '.')) : 0;
      if (isNaN(newDose)) newDose = 0
      if (newDose < 0) return

      const { suppliesWithCalculations, seed } = this.seedData;

      // Get the unprocessed supply (no calculations)
      // We get it so that we can recalculate its cost based on the new supply dose 
      const supplyFromDatabase = seed.supplies.find(s => s.supply._id === supplyId);

      const currentSupply = suppliesWithCalculations.find(s => s.id === supplyId);

      // Processed supply currently selected

      const processedSupply = this.processSupply(supplyFromDatabase, this.divisionSize, newDose);

      processedSupply.dose.value = newDose;
      // Processed supply that takes into account the new dose for its calculations

      // replace supply
      this.addSupply(processedSupply, newDose);
    },
    toggleAllSupplies() {
      const cost = this.calculations.supplyCostObject.totalSupplyCost;
      this.seedData.calculationsData.suppliesToggle = !this.seedData.calculationsData.suppliesToggle;
      this.areSuppliesOn = this.seedData.calculationsData.suppliesToggle;
      if (this.areSuppliesOn) {
        this.calculations.totalCost += cost;
      } else {
        this.calculations.totalCost -= cost;
      }
      this.calculations.profit = this.calculations.estimatedHarvestValue - this.calculations.totalCost;


      this.seedData.calculationsData.totalCost = this.calculations.totalCost
      this.seedData.calculationsData.profit = this.calculations.estimatedHarvestValue - this.calculations.totalCost;

    },

    toggleGasoil() {
      const cost = this.calculations.gasoilCost;
      this.seedData.calculationsData.gasoilToggle = !this.seedData.calculationsData.gasoilToggle;
      this.isGasoilOn = this.seedData.calculationsData.gasoilToggle;
      if (this.isGasoilOn) {
        this.calculations.totalCost += cost;
      } else {
        this.calculations.totalCost -= cost;
      }
      this.calculations.profit = this.calculations.estimatedHarvestValue - this.calculations.totalCost;


      this.seedData.calculationsData.totalCost = this.calculations.totalCost
      this.seedData.calculationsData.profit = this.calculations.estimatedHarvestValue - this.calculations.totalCost;

    },

    /**
     * Handles removing a supply based on type
     * 1. Removing object from array
     * 2. Using that object's cost to recalculate everything
     * 3. Empties min, max and actualDoses
     * @param {type} - Type of supply to be deleted, max 1 supply per type
    */
    removeSupply(type, supplyIndex) {
      const { supplyCostObject } = this.calculations
      this.calculations.supplyCostObject[this.supplyArraysMap[type]] = supplyCostObject[this.supplyArraysMap[type]].filter((supply, i) => {
        return i != supplyIndex
      });
      this.getTotalCosts({});
    },

    /**
     * Handles adding a supply, what it does is
     * 1. Add object to supplies array
     * 2. Using that object's cost to recalculate everything
     * 3. Sets doses
     * @param {object} - Object to be added
    */
    addSupply(newSupply) {
      let { supplyCostObject } = this.calculations;
      const suppliesArray = supplyCostObject[this.supplyArraysMap[newSupply.type]];
      if (suppliesArray.find(supply => supply.id == newSupply.id)) return;
      supplyCostObject[this.supplyArraysMap[newSupply.type]].push(newSupply);
      this.maxDose[newSupply.type] = newSupply.dose.max;
      this.minDose[newSupply.type] = newSupply.dose.min;
      // supplyCostObject.totalSupplyCost = newTotalSupplyCost;
    },

    /*
    * @param {string} e - event representing a supply id
    * @param {string} supplyType - additive | phytosanitary | fertilizer | fertilizerAndPhytosanitary
    */
    async selectSupply(e) {
      if (!e) return;
      const { suppliesWithCalculations } = this.seedData;

      const selectedSupply = suppliesWithCalculations.find(s => s.id == e)

      this.addSupply(selectedSupply, selectedSupply.dose.recommended)
      this.getTotalCosts({})
    },
    async modifyGasoilDose(e) {

      let newDose = e ? parseFloat(e.toString().replace(/\,/g, '.')) : 0;

      if (newDose < 0) { return };

      const gasoilCost = this.calculate({ field: 'gasoilCost', gasoilDose: newDose, gasoilPricePerFormat: this.calculations.gasoilPricePerFormat, divisionSize: this.divisionSize })
      let totalCost;
      if (this.areSuppliesOn) {
        totalCost = BigNumber(this.calculations.bagsCost)
          .plus(BigNumber(gasoilCost))
          .plus(BigNumber(this.calculations.supplyCostObject.totalSupplyCost))
          .toNumber();
      } else {
        totalCost = BigNumber(this.calculations.bagsCost)
          .plus(BigNumber(gasoilCost))
          .toNumber();
      }

      const profit = BigNumber(this.calculations.estimatedHarvestValue).minus(BigNumber(totalCost)).toNumber();

      this.seedData.seed.gasoil.recommended = Number(e)
      this.calculations.gasoilCost = gasoilCost;
      this.calculations.totalCost = totalCost;
      this.calculations.profit = profit;
    },
    async modifyPerformancePerHectare(e) {
      /* const formatted = utils.replaceCommaWithDot(e)
      let bagsPerHectare = e ? parseFloat(e.toString().replace(/\,/g, '.')) : 0;
      if (bagsPerHectare < 0) return; */
      let newValue = e ? parseFloat(e.toString().replace(/\,/g, '.')) : 0;
      if (newValue < 0) { return };

      const estimatedHarvestInTons = this.calculate({ field: 'estimatedHarvestInTons', performancePerHectare: newValue, divisionSize: this.divisionSize });
      const estimatedHarvestInQuintals = this.calculate({ field: 'estimatedHarvestInQuintals', estimatedHarvestInTons });
      const seedMarketValue = await this.getProductPrice(this.seedData.seed.product);
      const estimatedHarvestValue = this.calculate({ field: 'estimatedHarvestValue', estimatedHarvestInTons, seedMarketValue });
      const profit = this.calculate({ field: 'profit', estimatedHarvestValue, totalCost: this.calculations.totalCost });


      this.seedData.seed.performancePerHectare.estimate = newValue
      this.calculations.profit = profit;
      this.calculations.estimatedHarvestValue = estimatedHarvestValue;
      this.calculations.estimatedHarvestInQuintals = estimatedHarvestInQuintals;
      this.calculations.estimatedHarvestInTons = estimatedHarvestInTons;
    },
    async getProductPrice(productId) {
      this.product = await this.getProductsById(productId);
      return this.product.price.price;
    },
    async modifyBagsPerHectare(e, seed, gasoilDose) {
      let bagsPerHectare = e ? parseFloat(e.toString().replace(/\,/g, '.')) : 0;
      if (bagsPerHectare < 0) return;

      const bagsNeeded = this.calculate({ field: 'bagsNeeded', bagPerHec: bagsPerHectare, divisionSize: this.divisionSize })
      const pricePerBagPerAmount = this.getPricePerBagPerAmount(bagsNeeded, seed.pricePerBag);
      const bagsCost = this.calculate({ field: 'bagsCost', bagsNeeded, pricePerBagPerAmount })

      const gasoilCost = this.calculations.gasoilCost;

      let totalCost
      if (this.isGasoilOn && this.areSuppliesOn) {
        totalCost = BigNumber(bagsCost).plus(BigNumber(gasoilCost)).plus(BigNumber(this.calculations.supplyCostObject.totalSupplyCost)).toNumber();
      } else if (!(this.isGasoilOn || this.areSuppliesOn)) {
        totalCost = BigNumber(bagsCost).toNumber();
      } else if (!this.isGasoilOn) {
        totalCost = BigNumber(bagsCost).plus(BigNumber(this.calculations.supplyCostObject.totalSupplyCost)).toNumber();
      } else {
        totalCost = BigNumber(bagsCost).plus(BigNumber(gasoilCost)).toNumber();
      }

      const profit = this.calculate({ field: 'profit', estimatedHarvestValue: this.calculations.estimatedHarvestValue, totalCost })

      this.seedData.seed.bagsPerHectare.recommended = bagsPerHectare;
      this.calculations.bagsNeeded = bagsNeeded;
      this.calculations.pricePerBagPerAmount = pricePerBagPerAmount;
      this.calculations.bagsCost = bagsCost;
      this.calculations.profit = profit;
      this.calculations.gasoilCost = gasoilCost;
      this.calculations.totalCost = totalCost;
    },
    getPricePerBagPerAmount(amountOfBags, pricePerBagArray) {
      let priceToBeReturned;
      for (let i = 0; i < pricePerBagArray.length; i++) {
        if (amountOfBags > pricePerBagArray[i].from && amountOfBags <= pricePerBagArray[i].to) {
          priceToBeReturned = pricePerBagArray[i].price;
          break;
        } else {
          priceToBeReturned = pricePerBagArray[pricePerBagArray.length - 1].price;
          break;
        }
      }
      return priceToBeReturned;
    },
  },
};
</script>

<style scoped>
.table-text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.gray-background {
  background-color: #f0f0f0;
}

.accordion-button {
  background-color: #fff !important;
  width: auto;
}

#whiteAccordionButton {
  background-color: transparent !important;
}

.linethrough {
  text-decoration: line-through;
}

.red-bg-color {
  background-color: #fdd5c9;
}

.soft-blue-bg-color {
  background-color: #e0e7f1;
}

.white-bg-color {
  background-color: white !important;
}

.form-switch {
  margin: auto;
  padding-left: 1.35em;
}

.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: 0;
}

.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: none !important;
}

.table-border {
  border: 1px solid #A8A8A8;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion-button {
  padding: 0px 0px !important;
  margin: 0px !important;
  display: flex;
}

.accordion {
  --bs-accordion-btn-focus-border-color: none !important;
  --bs-accordion-btn-focus-box-shadow: none !important;
}

.accordion {
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' stroke-linejoin='round' stroke-miterlimit='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m12.002 2c5.518 0 9.998 4.48 9.998 9.998 0 5.517-4.48 9.997-9.998 9.997-5.517 0-9.997-4.48-9.997-9.997 0-5.518 4.48-9.998 9.997-9.998zm0 1.5c-4.69 0-8.497 3.808-8.497 8.498s3.807 8.497 8.497 8.497 8.498-3.807 8.498-8.497-3.808-8.498-8.498-8.498zm-.747 7.75h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75z' fill-rule='nonzero'/%3E%3C/svg%3E");
  --bs-accordion-btn-icon-width: 1.75rem;
  --bs-accordion-btn-icon-transform: rotate(180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' stroke-linejoin='round' stroke-miterlimit='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m12.002 2.005c5.518 0 9.998 4.48 9.998 9.997 0 5.518-4.48 9.998-9.998 9.998-5.517 0-9.997-4.48-9.997-9.998 0-5.517 4.48-9.997 9.997-9.997zm0 1.5c-4.69 0-8.497 3.807-8.497 8.497s3.807 8.498 8.497 8.498 8.498-3.808 8.498-8.498-3.808-8.497-8.498-8.497zm4.253 7.75h-8.5c-.414 0-.75.336-.75.75s.336.75.75.75h8.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z' fill-rule='nonzero'/%3E%3C/svg%3E");
}

.accordion-opened {
  z-index: 50;
  margin: 25px 0;
  border: 1px solid black;
  box-shadow: 0px 0px 20px 2px black;
  background-color: white;
  background: white;
}

.form-check-input:checked {
  background-color: goldenrod;
  border-color: goldenrod;
}

.table-info {
  /* background-color: #EEEEEE;
  background-color: green; */
  background-color: var(--light-gray);
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.table-info-first {
  border-left: 1px solid black;
}

.fila-accordion {
  line-height: 1.9;
}


.switch-suministros {
  position: relative;
  /* left: 2vw; */
  top: -0.25rem;
}


.div-accordion-button-rentabilidad {
  background-color: transparent;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  border-right: 1px solid #000;
  /* border: none */
}

.custom-input {
  border: 0.5px solid #E0E0E6;
  font-family: inherit;
  border-radius: 3px;
  padding: 5px;
  width: 100%;
  background-color: #fff;
  caret-color: var(--primary-color);
}

.custom-input:focus {
  border: 1px solid var(--primary-color);
  transition: 0.1s ease-in-out;
}

.custom-input:hover {
  border: 1px solid var(--primary-color);
  transition: border 0.1s ease-in-out;
}


@media screen and (max-width: 770px) {
  .accordion-button {
    padding: 16px 0px;
  }

  .trash-responsive {
    padding: 0px 0px;
  }

  .table-info {
    /* background-color: #EEEEEE;
  background-color: green; */
    background-color: var(--light-gray);
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.7rem;
  }

  .text-inside-accordion {
    font-size: 0.7rem;
  }

  .gasoil-switch {
    padding-left: 16.5vw;
  }

  .switch-suministros {
    position: relative;
    left: 2vw;
    top: -1vw;
  }

  .text-inside-accordion-desplegable {
    font-size: 0.4rem !important;
    --n-font-size: 0.4rem !important;
  }

  .div-container-accordion-button {
    padding: 0.05rem;
  }

  .div-accordion-button-rentabilidad {
    padding: 0.15rem !important;
    padding-top: 0.2rem !important;
    background-color: transparent;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    border-right: 1px solid #000;
    /* border: none */
  }

  .div-accordion-button-inside {
    /* position: relative;
    left: 30px; */
  }

  .accordion-button-inside {
    background-color: transparent !important;
  }

  .trash-responsive {
    --n-border: 1px solid transparent !important;
  }




}
</style>
